import orderBy from 'lodash/orderBy'

export function append (collection, key, val) {
  const newCollection = new Map(collection)
  newCollection.set(key, val)

  return newCollection
}

export function remove (collection, key) {
  const newCollection = new Map(collection)
  newCollection.delete(key)

  return newCollection
}

export function orderByValue (collection, path, direction = 'asc') {
  const oldArray = Array.from(collection)
  const reordered = orderBy(oldArray, `1.${path}`, direction)

  return new Map(reordered)
}
